import axios from '../../library/modules/axios'
// 查询消息记录
export function getRecord(data) {
  return axios.service({
    url: '/apis/v1/notification/customer/site_message/get_message_record',
    method: 'post',
    data
  })
}
// 查询消息类型
export function getType(params) {
  return axios.service({
    url: '/apis/v1/notification/customer/site_message/type',
    method: 'get',
    params
  })
}
// 修改消息记录为已读
export function updateReadState(params) {
  return axios.service({
    url: `/apis/v1/notification/customer/site_message/update_read_state`,
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    params,
    data: {}
  })
}
// 查询消息详情 埋点用
export function getMessageDetial(id) {
  return axios.service({
    url: `/apis/v1/notification/customer/site_message/task/${id}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
  })
}